import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

const UGL_LOGO = "/ugl-logo.png";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen section-dark text-white" role="main" aria-label="Privacy Policy">
      <header className="glass-header bg-[#001830]/90 border-b border-white/10 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 sm:px-12 flex items-center justify-between h-14">
          <Link to="/" className="flex items-center gap-3">
            <img src={UGL_LOGO} alt="UGL" className="w-8 h-8 object-contain" />
            <span className="font-semibold text-white text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>UGL Lariano</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" size="sm" className="text-white/60 hover:text-white hover:bg-white/5">
              <ArrowLeft className="w-4 h-4 mr-1" /> Torna alla Home
            </Button>
          </Link>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 sm:px-12 py-16">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-px w-8 bg-[#C9A84C]/60" />
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#C9A84C]">Informativa Legale</p>
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>Privacy Policy</h1>
        <div className="flex items-center gap-3 mb-10">
          <div className="h-px w-12 bg-[#C9A84C]/40" />
          <div className="w-2 h-2 rotate-45 border border-[#C9A84C]/40" />
          <div className="h-px w-20 bg-[#C9A84C]/30" />
        </div>

        <div className="space-y-8 text-white/60 leading-relaxed" style={{ fontFamily: "'Georgia', serif" }}>
          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Titolare del Trattamento</h2>
            <p>Il Titolare del trattamento dei dati personali e UGL - Unione Generale del Lavoro, Sezione Lariano, con sede in Lariano (RM). Per qualsiasi informazione relativa al trattamento dei dati personali e possibile contattare il Titolare all'indirizzo email: info@ugllariano.it o al numero di telefono: 351 413 4225.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Tipologie di Dati Raccolti</h2>
            <p>Fra i Dati Personali raccolti da questa Applicazione, in modo autonomo o tramite terze parti, ci sono: codice fiscale, nome, cognome, email, numero di telefono, dati di navigazione (cookie tecnici), dati relativi al curriculum vitae degli iscritti.</p>
            <p className="mt-3">I Dati Personali possono essere liberamente forniti dall'Utente o, nel caso di Dati di Utilizzo, raccolti automaticamente durante l'uso di questa Applicazione.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Finalita del Trattamento</h2>
            <p>I Dati dell'Utente sono raccolti per le seguenti finalita:</p>
            <ul className="list-disc list-inside mt-3 space-y-2">
              <li>Gestione dell'iscrizione al sindacato e accesso all'area riservata</li>
              <li>Gestione dei bandi, progetti e iniziative sindacali</li>
              <li>Creazione e gestione del curriculum vitae degli iscritti</li>
              <li>Comunicazioni relative alle attività sindacali</li>
              <li>Adempimento di obblighi di legge</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Base Giuridica del Trattamento</h2>
            <p>Il trattamento dei Dati Personali e lecito in quanto: l'Utente ha prestato il consenso per una o piu finalita specifiche; il trattamento e necessario all'esecuzione di un contratto con l'Utente; il trattamento e necessario per adempiere un obbligo legale; il trattamento e necessario per il perseguimento del legittimo interesse del Titolare.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Trasferimento Dati Extra-UE</h2>
            <p>I dati personali dell'Utente sono conservati su server situati negli Stati Uniti d'America. Il trasferimento avviene sulla base delle Clausole Contrattuali Standard (SCC) approvate dalla Commissione Europea (Decisione di Esecuzione 2021/914/UE), che garantiscono un livello di protezione adeguato ai sensi del GDPR.</p>
            <p className="mt-3"><strong className="text-[#C9A84C]">Misure di sicurezza supplementari adottate:</strong></p>
            <ul className="list-disc list-inside mt-2 space-y-2">
              <li>Crittografia AES-256 di tutti i dati personali sensibili (email, telefono) nel database</li>
              <li>Crittografia HTTPS/TLS per tutti i dati in transito</li>
              <li>Autenticazione a tre fattori (Codice Fiscale + PIN 8 cifre + Password)</li>
              <li>Sistema di rate limiting contro accessi non autorizzati</li>
              <li>Token JWT con scadenza temporale per le sessioni</li>
              <li>Controllo degli accessi basato su ruoli (admin, collaboratore, iscritto)</li>
            </ul>
            <p className="mt-3">Utilizzando la piattaforma, l'Utente acconsente espressamente al trasferimento dei propri dati personali negli Stati Uniti, consapevole che tali dati sono protetti dalle misure di sicurezza sopra descritte. L'Utente può revocare il consenso in qualsiasi momento scrivendo a info@ugllariano.it, con conseguente cessazione dell'accesso alla piattaforma.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Modalità di Trattamento e Sicurezza</h2>
            <p>Il Titolare adotta le opportune misure di sicurezza volte ad impedire l'accesso, la divulgazione, la modifica o la distruzione non autorizzate dei Dati Personali. In particolare:</p>
            <ul className="list-disc list-inside mt-2 space-y-2">
              <li>I dati sensibili (email, telefono) sono criptati con algoritmo AES-256 prima della memorizzazione nel database</li>
              <li>Le comunicazioni tra il browser dell'Utente e i server avvengono esclusivamente tramite protocollo HTTPS con certificato SSL/TLS</li>
              <li>L'accesso alla piattaforma è protetto da un sistema a tre fattori: Codice Fiscale, PIN numerico a 8 cifre e Password alfabetica a 4 caratteri</li>
              <li>Dopo 5 tentativi di accesso errati, l'account viene bloccato per 15 minuti</li>
              <li>I token di sessione hanno una scadenza di 24 ore</li>
            </ul>
            <p className="mt-3">Il trattamento viene effettuato mediante strumenti informatici e/o telematici, con modalità organizzative e con logiche strettamente correlate alle finalità indicate.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>7. Periodo di Conservazione</h2>
            <p>I Dati sono trattati e conservati per il tempo richiesto dalle finalita per le quali sono stati raccolti. I Dati Personali raccolti per l'esecuzione di un contratto saranno conservati sino a quando sia completata l'esecuzione di tale contratto.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>8. Diritti dell'Utente</h2>
            <p>Gli Utenti possono esercitare determinati diritti con riferimento ai Dati trattati dal Titolare, tra cui il diritto di accesso, rettifica, cancellazione, opposizione, limitazione del trattamento e portabilità dei dati. In particolare, l'Utente ha il diritto di revocare il consenso al trasferimento dei dati extra-UE in qualsiasi momento. Per esercitare i propri diritti, l'Utente può indirizzare una richiesta a: info@ugllariano.it</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>9. Riferimenti Normativi</h2>
            <p>La presente informativa privacy è redatta ai sensi del Regolamento (UE) 2016/679 (GDPR), del D.Lgs. 196/2003 e successive modifiche (Codice Privacy), e delle Clausole Contrattuali Standard della Commissione Europea per il trasferimento di dati personali verso paesi terzi (Decisione di Esecuzione 2021/914/UE).</p>
          </section>

          <div className="pt-6 border-t border-white/10">
            <p className="text-xs text-white/30">Ultimo aggiornamento: Marzo 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
}
